import React, { useState } from 'react'
import { pascalCase } from 'change-case'
import { connect } from 'react-redux'
import { Field, SubmissionError } from 'redux-form'
import { Button, Confirm } from 'semantic-ui-react'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { actionShortList, updateShortList } from 'ducks/shortList'
import { Cont } from './styled'
import { validateGeneralForm, validateVendorForm } from '../../attributeData'

import r from 'reactotron-react-js'

const SubmitForm = (props) => {
  const { handleSubmit, valueForm, history } = props
  const approverAction = valueForm.actions || []
  
  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const submitValidate = (action) => {
    setSubmitActionName(action)
    var errors = {}
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
      .then(() => {
        if (action.toLowerCase() === 'reject' || action.toLowerCase() === 'revise' || action.toLowerCase() === 'cancel') {
          if ((valueForm.comment && valueForm.comment.trim().length === 0) || !valueForm.comment) {
            errors.comment = 'Required!'
            scrollToFirstValidateFailElement(errors)
            throw new SubmissionError(errors)
          }
        } else {
          if (action.toLowerCase() === 'resubmit' && valueForm.statusActivity === 'Procurement') {
            errors = validateGeneralForm(valueForm, errors)
            errors = validateVendorForm(valueForm.vendors || [], errors)
          }
          
          if (Object.keys(errors).length) {
            scrollToFirstValidateFailElement(errors)
            throw new SubmissionError(errors)
          }
        }
        setShowConfirm(true)
      })
  }

  const callUpdate = () => {
    
  }

  const submitAction = () => {
    setShowConfirm(false)
    
    if (valueForm.statusActivity === 'Committee') {
      var committeeResult = valueForm.vendors.map((x) => ({
        shortListVendorId: x.id,
        evaluation: x.evaluation,
        comment: x.comment
      }))

      props.actionShortList({ 
        id: valueForm.id, 
        comment: valueForm.comment,
        sn: valueForm.sn,
        action: submitActionName,
        committeeResult: JSON.stringify(committeeResult),
        attachments: valueForm.commentAttachment }, history)
    } else {
      // Save and submit
      props.updateShortList(valueForm, false, history, submitActionName)
    }
  }

  return (
    approverAction.length === 0 ? null :
      <StdCard title='Action for Approval' highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
        <Cont>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Field
              name='comment'
              label='Your Comment'
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
            <Field
              name='commentAttachment'
              label='Attachments'
              type={type.file}
              component={FieldInput}
              containerStyle={{ marginRight: 0 }}
            />
            <div style={{ marginTop: '1rem', display: 'flex' }}>
              {
                approverAction.map((item) =>
                  <Button
                    key={item}
                    type='button'
                    color={`${(item.toLowerCase() === 'reject' || item.toLowerCase() === 'cancel') ? 'red' : item.toLowerCase() === 'revise' ? 'orange' : 'green'}`}
                    onClick={handleSubmit(() => submitValidate(item))}
                  >
                    {pascalCase(item)}
                  </Button>
                )
              }
            </div>
          </div>
          <Confirm
            size='mini'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />
        </Cont>
        <Confirm 
          open={showConfirmModal}
          header='Warning!'
          content={
            <div style={{ padding: '1.25rem' }}>
              <p>Are you sure to submit Short List data?</p>
            </div>
          }
          confirmButton='Yes'
          cancelButton='No'
          onConfirm={() => {
            setShowConfirmModal(false)
            callUpdate()
          }}
          onCancel={() => setShowConfirmModal(false)}
        />
      </StdCard>
  )

}

const mapStateToProps = (state) => {
  return ({
  })
}

const mapDispatchToProps = {
  actionShortList,
  updateShortList
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitForm)
